/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Wh_PackagingInputs */

const vi_sinp_wh_packaging = /** @type {(inputs: Sinp_Wh_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho bao bì`)
};

/**

* @param {Sinp_Wh_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_wh_packaging = /** @type {((inputs?: Sinp_Wh_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Wh_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_wh_packaging(inputs)
});